import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';

import {MatTableDataSource} from '@angular/material';
import { ItemGrid } from '../../../../models/item';
import { modalComponent } from '../../../../utils/modal/modal.component';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../../../services/general.service';
import { DataService } from '../../../../utils/data.service';
import { DataSourceGrid } from '../../../../utils/data-source-grid.component';
import { ActivatedRoute,Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { FormBuilder, FormGroup } from '@angular/forms';
import {SelectionModel} from '@angular/cdk/collections';

import { Usuario } from '../../../../models/usuario';
import { modalConfirmationComponent } from '../../../../utils/modal/modal-confirmation.component';

export interface PolizaElement {
  cargos: number;
  abonos: number;
  estatus: string;
  tipo:string;
  
  select:boolean;
  COMPANY_ID: number;
  CREATED_BY:number;
  CREATION_DATE: Date;
  DESCRIPTION:string;
  NUMBER:string;
  ORGANIZATION_ID:number;
  POLIZA_ID:number;
  POLIZA_STATUS_ID:number;
  POLIZA_TYPE_ID:number;
  ELEMENT_DETAIL_DATA: PolizaDetailElement[];
}
export interface PolizaStatusElement {
  POLIZA_STATUS_ID: number;
  NAME:string;
}
export interface PolizaTypeElement {
  POLIZA_TYPE_ID: number;
  NAME:string;
}
export interface PolizaDetailAccountElement {
  ACCOUNT_ID: number;
  CUENTA:string;
}
export interface PolizaDetailElement{
  POLIZA_DETAIL_ID:number;
  POLIZA_ID:number;
  POLIZA_DETAIL_NUMBER:string;
  ACCOUNT_ID:number;
  ACCOUNT_DESC:string;
  DESCRIPTION:string;
  CONCEPT:string;
  REFERENCE:string;
  CARGO:number;
  ABONO:number;
  editando:boolean;
}
@Component({
  selector: 'app-polizas-agregar-view',
  templateUrl: './polizas-agregar-view.component.html',
  styleUrls: ['./polizas-agregar-view.component.scss'],
  providers: [generalService]
})
export class PolizasAgregarViewComponent implements OnInit  {
  ELEMENT_DATA: PolizaElement[] =[]
  ELEMENT_DETAIL_DATA: PolizaDetailElement[] =[]
  
  ELEMENT_DETAIL_ACCOUNT_DATA: PolizaDetailAccountElement[] =[]
  detailAddSel: PolizaDetailElement={
    POLIZA_DETAIL_ID:0,
    POLIZA_ID:0,
    POLIZA_DETAIL_NUMBER:"",
    ACCOUNT_ID:0,
    ACCOUNT_DESC:"",
    DESCRIPTION:"",
    CONCEPT:"",
    REFERENCE:"",
    CARGO:0,
    ABONO:0,
    editando:false
  }
  
  polizaStatus_DATA:PolizaStatusElement[]=[]
  polizaType_DATA:PolizaTypeElement[]=[]
  selPoliza:PolizaElement=null
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(private formBuilder: FormBuilder,
    private _generalService: generalService,
  private router:Router,public dialog: MatDialog,) {
        this.myForm = new FormGroup({});
    }

ngOnInit() {
  this.buildForm();

  //this.consultarHistoricoPoliza();
}
salir(){  
  this.router.navigate([ '/app/polizas'])
    .then(nav => {
      console.log(nav); // true if navigation is successful
    }, err => {
      console.log(err) // when there's an error
    });
}
private polizaService = 'poliza/';

crearPoliza(){
  const fechaSel = this.fechaPago.format('YYYY-MM-DD');
  const rangoInicio = moment().format('YYMM');
  let consecutivo="POL"+rangoInicio  
  console.warn(consecutivo);

  const usuario: Usuario = JSON.parse(sessionStorage.getItem('user'));
  const organizationId = usuario.ORGANIZATION_ID;
  let estatusSend=this.myForm.get('estatusForm').value
  let tipoFormSend=this.myForm.get('tipoForm').value
  let descripcionFormSend=this.myForm.get('descripcionForm').value
  
  //let numberSend=this.myForm.get('numPolizasForm').value
  
  console.warn(rangoInicio);
  console.warn(estatusSend==''?null:estatusSend)
  //console.warn(numberSend ==''?null:numberSend)
  if(tipoFormSend>0){

    if(this.TOTAL_CARGO>0 && this.TOTAL_ABONO>0 && this.TOTAL_CARGO==this.TOTAL_ABONO){
        this._generalService.metodoCallParams(
          {
            NUMBER:consecutivo,
            POLIZA_TYPE_ID:tipoFormSend,
            CREATION_DATE:fechaSel,
            CREATED_BY:usuario.USER_ID,
            POLIZA_STATUS_ID:estatusSend==''?null:estatusSend,
            DESCRIPTION:descripcionFormSend,
            ORGANIZATION_ID:organizationId,
            COMPANY_ID:usuario.COMPANY_ID,
            ELEMENT_DETAIL_DATA:this.dataSource.data
          },this.polizaService + `crearPoliza`, true)
          .subscribe((polizaCreada) => {
            console.warn(polizaCreada)
            this._generalService.toastCall('Poliza creada correctamente.');
            this.router.navigate([ '/app/polizas'])
            .then(nav => {
              console.log(nav); // true if navigation is successful
            }, err => {
              console.log(err) // when there's an error
            });

          }, (error) => {
          });
  
      }else{
        this._generalService.toastCall('Cargo y Abono deben de sumar la misma cantidad y mayor a 0.');
      }
  }else{
    this._generalService.toastCall('Selecciona tipo de poliza.');
  }
}

consultarConsecutivo() {
  const rangoInicio = moment().format('YYMM');
  let consecutivo="POL"+rangoInicio  
  console.warn(consecutivo);

  const usuario: Usuario = JSON.parse(sessionStorage.getItem('user'));
  console.warn("usuario",usuario)
  const organizationId = usuario.ORGANIZATION_ID;
  let estatusSend=this.myForm.get('estatusForm').value
  //let numberSend=this.myForm.get('numPolizasForm').value
  
  console.warn(rangoInicio);
  console.warn(estatusSend==''?null:estatusSend)
  //console.warn(numberSend ==''?null:numberSend)
  
  this._generalService.metodoCallParams(
  {
  POLIZA_STATUS_ID:estatusSend==''?null:estatusSend,
  //NUMBER:numberSend ==''?null:numberSend,
  FECHA_INICIO:rangoInicio,
  ORGANIZATION_ID:organizationId,
  
  },this.polizaService + `consultarPoliza`, true)
  .subscribe((historicos) => {
  console.warn(historicos)
  this.ELEMENT_DATA=historicos
  //this.dataSource.data=historicos
  //this.actualizarGrid.next(historicos);
  }, (error) => {
  });
  }
consultarHistoricoPoliza() {
const rangoInicio = this.dateRange.startDate.format('YYYY-MM-DD');
const rangoFinal = this.dateRange.endDate.format('YYYY-MM-DD');

const usuario: Usuario = JSON.parse(sessionStorage.getItem('user'));
  console.warn("usuario",usuario)
  const organizationId = usuario.ORGANIZATION_ID;
let estatusSend=this.myForm.get('estatusForm').value
//let numberSend=this.myForm.get('numPolizasForm').value

console.warn(rangoInicio);
console.warn(rangoFinal);
console.warn(estatusSend==''?null:estatusSend)
//console.warn(numberSend ==''?null:numberSend)

//consultarPoliza
//this._generalService.metodoCallParams({},this.polizaService + `/consultarHistoricoCorte?organizationId=${organizationId}&&rangoInicio=${rangoInicio}&&rangoFinal=${rangoFinal}`, true)
this._generalService.metodoCallParams(
{
POLIZA_STATUS_ID:estatusSend==''?null:estatusSend,
//NUMBER:numberSend ==''?null:numberSend,
FECHA_INICIO:rangoInicio,
FECHA_FIN:rangoFinal,
ORGANIZATION_ID:organizationId,

},this.polizaService + `consultarPoliza`, true)
.subscribe((historicos) => {
console.warn(historicos)
this.ELEMENT_DATA=historicos
//this.dataSource.data=historicos
//this.actualizarGrid.next(historicos);
}, (error) => {
});
}

consultarPolizaStatus() {
  const usuario: Usuario = JSON.parse(sessionStorage.getItem('user'));
  console.warn("usuario",usuario)
  const organizationId = usuario.ORGANIZATION_ID;
  //consultarPoliza
  this._generalService.metodoCallParams({},this.polizaService + `consultarPolizaStatus`, true)
  .subscribe((polizaStatus) => {
  console.warn(polizaStatus)
  this.polizaStatus_DATA=polizaStatus
    this.myForm.patchValue({
      estatusForm:[1]
    })
    
    this.myForm.get('estatusForm').setValue(1)
    this.myForm.get('estatusForm').disable()

  }, (error) => {
  });
  }
  consultarPolizaType() {
  const usuario: Usuario = JSON.parse(sessionStorage.getItem('user'));
  const organizationId = usuario.ORGANIZATION_ID;
  //consultarPoliza
  this._generalService.metodoCallParams({},this.polizaService + `consultarPolizaType`, true)
  .subscribe((polizaType) => {
  console.warn(polizaType)
  this.polizaType_DATA=polizaType
  }, (error) => {
  });
  }
  
  consultarContAccount() {
    const usuario: Usuario = JSON.parse(sessionStorage.getItem('user'));
    const organizationId = usuario.ORGANIZATION_ID;
    //consultarPoliza
    
    this._generalService.metodoCallParams({
      ORGANIZATION_ID:organizationId,
      COMPANY_ID:usuario.COMPANY_ID
    },this.polizaService + `consultarContAccount`, true)
    .subscribe((polizaAccount) => {
    console.warn(polizaAccount)
    this.ELEMENT_DETAIL_ACCOUNT_DATA=polizaAccount
    this.eLEMENT_DETAIL_ACCOUNT_DATA_AUX = this.ELEMENT_DETAIL_ACCOUNT_DATA
    }, (error) => {
    });
    }
  //FECHA = this.reciboPagoAgregar.controls['fechaPago'].value.format('YYYY-MM-DD');
  fechaPago:any=moment()
buildForm(){
  this.myForm = this.formBuilder.group({
    fechaPago: [''],
    //numPolizasForm:  [''] ,
    estatusForm: [''],
    tipoForm:[''],
    descripcionForm:['']
  });

  //this.myForm.get('numPolizasForm').disable()
  this.consultarPolizaStatus();
  this.consultarPolizaType();
  this.consultarContAccount();
  this.consultarConsecutivo();

}

mostrarAdd:boolean=false
mostrarModalAgregar(){
  console.warn("Agregando")
  this.detailAddSel={
    POLIZA_DETAIL_ID:0,
    POLIZA_ID:0,
    POLIZA_DETAIL_NUMBER:""+(this.dataSource.data.length+1),
    ACCOUNT_ID:0,
    ACCOUNT_DESC:"",
    DESCRIPTION:"",
    CONCEPT:"",
    REFERENCE:"",
    CARGO:0,
    ABONO:0,
    editando:false
  }
  this.mostrarAdd=true
  console.warn("Agregando",this.detailAddSel)

  //this.ELEMENT_DETAIL_DATA.push();
  
}
cambiarCargoAbono(tipo:string){
  if(tipo=='CARGO'){
    this.detailAddSel.ABONO=0;
  }else
  if(tipo=='ABONO'){
    this.detailAddSel.CARGO=0;
  }
}
 //asignamos el paginator y el sort al datasource una vez la vista este inicializada.
 ngAfterViewInit() {
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.sort; 
}
TOTAL_ABONO:number=0
TOTAL_CARGO:number=0
guardarDetail(){
  console.warn("guardarDetail")
  this.eLEMENT_DETAIL_ACCOUNT_DATA_AUX = this.ELEMENT_DETAIL_ACCOUNT_DATA
  //for(var i=0;i<300;i++){
    if(this.detailAddSel.ACCOUNT_ID>0){

      if(this.detailAddSel.ABONO>0 || this.detailAddSel.CARGO>0 ){
        if(this.detailAddSel.ABONO>0  ){
          //this.TOTAL_ABONO += this.detailAddSel.ABONO;
          this.TOTAL_ABONO = parseFloat((this.TOTAL_ABONO + this.detailAddSel.ABONO).toFixed(2));
        }else if(this.detailAddSel.CARGO>0 ){
          //this.TOTAL_CARGO += this.detailAddSel.CARGO;
          this.TOTAL_CARGO = parseFloat((this.TOTAL_CARGO + this.detailAddSel.CARGO).toFixed(2));
        }
        for(var i=0;i<this.ELEMENT_DETAIL_ACCOUNT_DATA.length;i++){
          if(this.ELEMENT_DETAIL_ACCOUNT_DATA[i].ACCOUNT_ID.toString()==this.detailAddSel.ACCOUNT_ID.toString()){
            this.detailAddSel.ACCOUNT_DESC= this.ELEMENT_DETAIL_ACCOUNT_DATA[i].CUENTA;
            break;
          }
        }
        this.ELEMENT_DETAIL_DATA.push(this.detailAddSel);
        this.dataSource.data=this.ELEMENT_DETAIL_DATA
        this.mostrarAdd=false;

      }else{
        this._generalService.toastCall('Ingresar cargo o abono.');
      }
    }else{
      this._generalService.toastCall('Favor de seleccionar Cuenta.');
    }
  //}

}
cancelarDetail(){
  this.eLEMENT_DETAIL_ACCOUNT_DATA_AUX = this.ELEMENT_DETAIL_ACCOUNT_DATA
  console.warn("cancelarDetail")
  this.detailAddSel={
    POLIZA_DETAIL_ID:0,
    POLIZA_ID:0,
    POLIZA_DETAIL_NUMBER:"",
    ACCOUNT_ID:0,
    ACCOUNT_DESC:"",
    DESCRIPTION:"",
    CONCEPT:"",
    REFERENCE:"",
    CARGO:0,
    ABONO:0,
    editando:false
  }
  this.mostrarAdd=false;
}
  checkCambiar(row:PolizaElement,event:any){
    console.warn("prev",event.checked)
    console.warn("prev",row)
    console.warn(this.dataSource.data)
    if(event.checked){

      if(this.selPoliza==null){
        this.selPoliza=row
        for(var i=0;i<this.dataSource.data.length;i++){
          if(this.dataSource.data[i].POLIZA_ID==this.selPoliza.POLIZA_ID){
            //this.dataSource.data[i].select=true;
            break;
          }
        }
      }else{
        for(var i=0;i<this.dataSource.data.length;i++){
          if(this.dataSource.data[i].POLIZA_ID==this.selPoliza.POLIZA_ID){
            //this.dataSource.data[i].select=false;
            this.selPoliza=row
                  
              for(var i=0;i<this.dataSource.data.length;i++){
                if(this.dataSource.data[i].POLIZA_ID==this.selPoliza.POLIZA_ID){
                  //this.dataSource.data[i].select=true;
                  this.selPoliza=row
                  break;
                }
              }
            break;
          }
        }
        
      }
    }else{
      
      for(var i=0;i<this.dataSource.data.length;i++){
        if(this.dataSource.data[i].POLIZA_ID==this.selPoliza.POLIZA_ID){
          //this.dataSource.data[i].select=false;
          this.selPoliza=null
          break;
        }
      }
    }
    
    console.warn("post",row)
    console.warn(this.dataSource.data)
  }
  myForm: FormGroup;
  
  dataSource = new MatTableDataSource<PolizaDetailElement>(this.ELEMENT_DETAIL_DATA);
  companyName = "";
  public dataReporteCuenta: any[] = [];

  dateRange: any = {
      startDate: moment().startOf('month'),
      //startDate: moment().subtract(7, 'days'),
      endDate: moment()
  };
  ranges: any = {
      'Hoy': [moment(), moment()],
      'Semana actual': [moment().startOf('week'), moment().endOf('week')],
      'Mes actual': [moment().startOf('month'), moment().endOf('month')]
  };

  displayedColumns = [
      'acciones', 
       //'POLIZA_DETAIL_ID',
       //'POLIZA_ID',
       'POLIZA_DETAIL_NUMBER',
       'ACCOUNT_ID',
       'DESCRIPTION',
       'CONCEPT',
       'REFERENCE',
       'CARGO',
       'ABONO'
  ];
  
  actualizarTotales(){
    this.TOTAL_ABONO=0
    this.TOTAL_CARGO=0
    for(var i=0;i<this.ELEMENT_DETAIL_DATA.length;i++){
      this.TOTAL_ABONO=this.TOTAL_ABONO+this.ELEMENT_DETAIL_DATA[i].ABONO
      this.TOTAL_CARGO=this.TOTAL_CARGO+this.ELEMENT_DETAIL_DATA[i].CARGO

    }
  }
  selEditPolizaElement:PolizaDetailElement
  selEditPolizaElementIndex:number
  editandoGlobal:boolean=false
  editPolizaDetail(row:PolizaDetailElement,indexSel:number){
    this.eLEMENT_DETAIL_ACCOUNT_DATA_AUX = this.ELEMENT_DETAIL_ACCOUNT_DATA
    //POLIZA_ID
    console.warn(row);
    console.warn(indexSel);
    this.selEditPolizaElement=row
    this.selEditPolizaElementIndex=indexSel
    this.editandoGlobal=true
    this.ELEMENT_DETAIL_DATA[indexSel].editando=true
    this.dataSource.data=this.ELEMENT_DETAIL_DATA
    this.actualizarTotales()
  }

  
  
  editPolizaDetailGuardar(row:PolizaDetailElement,indexSel:number){
    //POLIZA_ID
    console.warn(row);
    console.warn(indexSel);
    //this.selEditPolizaElement=row
    //this.selEditPolizaElementIndex=indexSel
    this.editandoGlobal=false
    this.ELEMENT_DETAIL_DATA[indexSel]=this.selEditPolizaElement
    this.ELEMENT_DETAIL_DATA[indexSel].editando=false


    for(var i=0;i<this.ELEMENT_DETAIL_ACCOUNT_DATA.length;i++){
      if(this.ELEMENT_DETAIL_ACCOUNT_DATA[i].ACCOUNT_ID.toString()==this.detailAddSel.ACCOUNT_ID.toString()){
        this.ELEMENT_DETAIL_DATA[indexSel].ACCOUNT_DESC= this.ELEMENT_DETAIL_ACCOUNT_DATA[i].CUENTA;
        break;
      }
    }

    this.dataSource.data=this.ELEMENT_DETAIL_DATA
    this.actualizarTotales()
  }
  cambiarCargoAbonoEdit(tipo:string){
    if(tipo=='CARGO'){
      this.selEditPolizaElement.ABONO=0;
    }else
    if(tipo=='ABONO'){
      this.selEditPolizaElement.CARGO=0;
    }
  }
  editPolizaDetailCancelar(row:PolizaDetailElement,indexSel:number){
    //POLIZA_ID
    console.warn(row);
    console.warn(indexSel);
    this.selEditPolizaElement=null
    this.selEditPolizaElementIndex=null
    this.editandoGlobal=false
    this.ELEMENT_DETAIL_DATA[indexSel].editando=false
    this.dataSource.data=this.ELEMENT_DETAIL_DATA
    this.actualizarTotales()
  }
  //cancelar
  confirmDeleteDetail(row:PolizaDetailElement,indexSel:number){
    //POLIZA_ID
    console.warn(row)
    const dialogRef = this.dialog.open(modalConfirmationComponent, {
      disableClose: true, data: {
        mensaje: '¿Desea eliminar el detalle: ' + row.POLIZA_DETAIL_NUMBER + '?. Se recorreran los numeros para tener una secuencia.',  }
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
      if(result == 1){
        //cambiar POLIZA_STATUS_ID=2
        console.warn("Eliminar: "+row.POLIZA_ID)
        

        
        this.ELEMENT_DETAIL_DATA.splice(indexSel,1);
        this.dataSource.data=this.ELEMENT_DETAIL_DATA
        this.actualizarTotales()
       }
    });
  }
  //cancelar
  confirmDelete(row:PolizaElement){
    //POLIZA_ID
    console.warn(row)
    const dialogRef = this.dialog.open(modalConfirmationComponent, {
      disableClose: true, data: {
        mensaje: '¿Desea cancelar la poliza: ' + row.NUMBER + '?',  }
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
      if(result == 1){
        //cambiar POLIZA_STATUS_ID=2
        console.warn("Eliminar: "+row.POLIZA_ID)
        
        this._generalService.metodoCallParams({POLIZA_ID:row.POLIZA_ID},this.polizaService + `cancelarPoliza`, true)
        .subscribe((polizaStatus) => {
          console.warn(polizaStatus)
          this.consultarHistoricoPoliza()
        }, (error) => {
        });

       }
    });
  }
  reactivateRow(row:PolizaElement){
    console.warn(row)
  }

  selection = new SelectionModel<PolizaElement>(true, []);

/** Whether the number of selected elements matches the total number of rows. */
isAllSelected() {
  const numSelected = this.selection.selected.length;
  const numRows = this.dataSource.data.length;
  return numSelected === numRows;
}

/** Selects all rows if they are not all selected; otherwise clear selection. */
masterToggle() {
  this.isAllSelected() ?
      this.selection.clear() :''
      //this.dataSource.data.forEach(row => this.selection.select(row));
}

polizasAdd(){
  
  this.router.navigate([ '/app/polizas/polizas-agregar'])
    .then(nav => {
      console.log(nav); // true if navigation is successful
    }, err => {
      console.log(err) // when there's an error
    });
  //this.router.url.subscribe(([url]) => {
  //  const { path, parameters } = url;
  //  console.log(path); // e.g. /products
  //  console.log(parameters); // e.g. { id: 'x8klP0' }
  //});
  //polizas/polizas-agregar
}
timeout: any;
public eLEMENT_DETAIL_ACCOUNT_DATA_AUX: any[] = [];
onKeyUpAccount(val: any) {
    

  if (this.timeout) {
      clearTimeout(this.timeout);
  }

  const searchValue = val.currentTarget.value.trim().toLowerCase();
  this.timeout = setTimeout(() => {
      

      let arr: any[];

      if (searchValue !== "") {
          arr = this.ELEMENT_DETAIL_ACCOUNT_DATA
              .filter((obj) => obj.CUENTA.toLowerCase().indexOf(searchValue) > -1)
              .slice(0, 100); // Limitar a los primeros 10 elementos
      } else {
          arr = this.ELEMENT_DETAIL_ACCOUNT_DATA.slice(0, 10); // Restaurar a los primeros 10 elementos del array original
      }
      
      //console.log("filtroCp: Resultado filtrado:", arr);
      this.eLEMENT_DETAIL_ACCOUNT_DATA_AUX = arr;
  }, 300); // Esperar 300 ms antes de ejecutar la búsqueda

  
}

}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/polizas/polizas-agregar/polizas-agregar-view/polizas-agregar-view.component.ts